'use client';

import { SearchCollection } from 'searchCollection';
import Image from 'next/image';
import Link from 'next/link';
import * as styles from './CategoriesContent.css';

export type CategoriesContentProps = {
  collections: SearchCollection;
};

function CategoriesContent({ collections }: CategoriesContentProps) {
  return (
    <div className={styles.CategoriesContentContainer}>
      <div className={styles.CategoriesTitleWrapper}>
        <h2 className={styles.CategoriesTitle}>Coleções</h2>
      </div>
      <div className={styles.CategoriesItemsWrapper}>
        {collections.matrices.map((matrix) => {
          const {
            collection_id, label, images: { icon }, slug,
          } = matrix;
          return (
            <div className={styles.CategoryItemWrapper}>
              <Link href={`/eventos/${slug}`} key={collection_id} className={styles.CategoryItem}>
                <div className={styles.CategoryItemImage}>
                  <Image
                    src={icon}
                    alt={`Ícone para ${label}`}
                    width={46}
                    height={46}
                  />
                </div>
                <div className={styles.CategoryItemLabel}>
                  <p>{label}</p>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CategoriesContent;
